import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { mapMutations, mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
export default {
  name: 'CoreToolbar',
  props: {
    breadcrumbs: {
      type: Array,
      required: false,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      containerWidth: 0,
      title: null,
      newTicketCount: 0,
      feedbackDialog: false,
      dialogTitle: '',
      dialogType: 'like'
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'refreshToolbar', 'announcements', 'permissions'])), mapState('authentication', ['user', 'isImpersonating'])), {}, {
    inputValue: {
      get: function get() {
        return this.$store.state.app.drawer;
      },
      set: function set(val) {
        this.setDrawer(val);
      }
    },
    showTicketNotificationBell: function showTicketNotificationBell() {
      return this.canReadTickets && this.newTicketCount > 0;
    },
    canCreateTickets: function canCreateTickets() {
      return this.permissions['IsFmTicket.create'] || this.permissions['IsFmTicket.manage'];
    },
    canReadTickets: function canReadTickets() {
      return this.permissions['IsFmTicket.read'] || this.permissions['IsFmTicket.manage'];
    },
    canScheduleExports: function canScheduleExports() {
      return this.permissions['VirtualDevice.read'] || this.permissions['DigitalTwin.read'];
    },
    canShowBulkEditJobs: function canShowBulkEditJobs() {
      return this.permissions['all.manage'] || this.permissions['VirtualDevice.manage'] || this.permissions['VirtualDevice.write'] || this.permissions['VirtualDevice.read'];
    },
    setTop: function setTop() {
      return [this.$store.state.app.bannerHeight ? {
        top: "".concat(this.$store.state.app.bannerHeight, "px")
      } : {
        top: '0px'
      }];
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    breadcrumbsWidth: function breadcrumbsWidth() {
      // 440px is a rough estimate for the width of the other components (email-address, buttons, ...)
      // absolute min-width (on mobile, probably) is 240px
      return "".concat(Math.max(240, Math.floor(this.containerWidth - 440)), "px");
    },
    breadcrumbsItems: function breadcrumbsItems() {
      if ((this.breadcrumbs || []).length) {
        return this.breadcrumbs;
      }

      return [this.$i18n_t(this.$route.meta.i18n)];
    }
  }),
  watch: {
    refreshToolbar: function refreshToolbar() {
      this.loadTicketNotifications();
    }
  },
  mounted: function mounted() {
    this.loadTicketNotifications();
    window.addEventListener('resize', this.debouncedCalculation);
    this.debouncedCalculation();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.debouncedCalculation);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('app', ['setDrawer', 'toggleDrawer'])), mapActions('authentication', ['logout', 'restoreOriginal'])), {}, {
    debouncedCalculation: debounce(function () {
      var currentWidth = get(this.$refs, 'toolbarContainer.$el', {}).clientWidth;
      this.containerWidth = currentWidth;
    }, 250),
    onClickBtn: function onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onRestore: function onRestore() {
      // eslint-disable-next-line promise/catch-or-return
      this.restoreOriginal().then(function () {
        // do a whole page reload, to clear the permission "cache" (i.e. the vue-store)
        window.location.reload();
      });
    },
    onLogout: function onLogout() {
      this.logout().then(function () {
        // Slightly inconvenient to have a full page load here
        // instead of SPA transition. But after an Error Boundary
        // the router stops working, so we use location.href to
        // make sure at least logout returns to the login screen.
        window.location.href = '/#/login';
      }).catch(function (error) {
        console.error(error);
      });
    },
    loadTicketNotifications: function loadTicketNotifications() {
      var _this = this;

      if (this.canReadTickets) {
        // fetch the count of tickets with state 'New'
        ApiService.isFmTicketsCount(this, null, [0]).then(function (data) {
          _this.newTicketCount = data;
        }).catch(function (error) {
          console.error(error);
        });
      }
    },
    getPath: function getPath(metaObj) {
      if (metaObj && metaObj.internalHelp) {
        return '/#/help';
      } else {
        return "".concat(this.$store.state.app.docsBaseURL);
      }
    },
    openDialog: function openDialog(data) {
      this.dialogTitle = data.title;
      this.dialogType = data.type;
      this.feedbackDialog = true;
    }
  })
};